



























import { Component, Vue } from "vue-property-decorator";
import store from "../store";
import GuidedHeader from "@/components/GuidedHeader/GuidedHeader.vue";
import GuidedList from "@/components/GuidedList/GuidedList.vue";
import GuidedListPlaceholder from "@/components/GuidedList/GuidedListPlaceholder.vue";
import { ListToBeDisplayed } from "../store/modules/delayCodes/utils";
import { ListItem } from "../store/modules/delayCodes/utils";
import { MapItems, MapRelations } from "../store/modules/delayCodes/state";
import { MutationsTypes } from "../store/modules/delayCodes/mutations";

@Component({
  components: {
    GuidedHeader,
    GuidedList,
    GuidedListPlaceholder
  }
})
export default class GuidedMode extends Vue {
  get selectedList(): ListToBeDisplayed {
    return store.state.delayCodes.selectedListToDisplay;
  }

  get listProcesses(): MapItems {
    if (store.state.delayCodes.selectedProcessId === null) {
      return store.state.delayCodes.processes;
    } else {
      return store.state.delayCodes.processes;
    }
  }

  get listReasons(): MapItems {
    if (store.state.delayCodes.selectedReasonId === null) {
      return store.state.delayCodes.reasons;
    } else {
      return store.state.delayCodes.reasons;
    }
  }

  get listStakeholders(): MapItems {
    if (store.state.delayCodes.selectedStakeholderId === null) {
      return store.state.delayCodes.stakeholders;
    } else {
      return store.state.delayCodes.stakeholders;
    }
  }

  get shouldDisplayDoorsStatus(): boolean {
    return this.selectedList === ListToBeDisplayed.Process;
  }

  get shouldDisplayList(): boolean {
    return this.selectedList !== ListToBeDisplayed.None;
  }

  get shouldDisplayBreakdown(): boolean {
    return (
      store.state.delayCodes.selectedProcessId !== null &&
      store.state.delayCodes.selectedReasonId !== null &&
      store.state.delayCodes.selectedStakeholderId !== null
    );
  }

  get selectedIdForList(): ListItem | undefined {
    switch (this.selectedList) {
      case ListToBeDisplayed.None: {
        return undefined;
      }
      case ListToBeDisplayed.Process: {
        return this.listToBeDisplayed.find(
          it => it.id === store.state.delayCodes.selectedProcessId
        );
      }
      case ListToBeDisplayed.Reason: {
        return this.listToBeDisplayed.find(
          it => it.id === store.state.delayCodes.selectedReasonId
        );
      }
      case ListToBeDisplayed.Stakeholder: {
        return this.listToBeDisplayed.find(
          it => it.id === store.state.delayCodes.selectedStakeholderId
        );
      }
      default: {
        return undefined;
      }
    }
  }

  get listToBeDisplayed(): ListItem[] {
    let map: MapItems | null = null;
    switch (this.selectedList) {
      case ListToBeDisplayed.None: {
        map = null;
        break;
      }
      case ListToBeDisplayed.Process: {
        map = this.listProcesses;
        break;
      }
      case ListToBeDisplayed.Reason: {
        map = this.listReasons;
        break;
      }
      case ListToBeDisplayed.Stakeholder: {
        map = this.listStakeholders;
        break;
      }
      default: {
        map = null;
        break;
      }
    }

    const _listToBeDisplayed: ListItem[] = [];
    if (map !== null) {
      const subStakeholders: MapRelations | undefined =
        store?.state?.delayCodes?.rawData?.subStakeholders;
      Object.keys(map).forEach(key => {
        const children = this.getChildrenFor(
          Number(key),
          subStakeholders ? subStakeholders : {}
        );
        _listToBeDisplayed.push({
          id: parseInt(key),
          value: map !== null ? map[key] : "",
          subItemOf: subStakeholders ? subStakeholders[key] : undefined,
          parentOf: children
        });
      });
    }
    _listToBeDisplayed.sort((it1, it2) => {
      let valIt1 = "";
      if (it1.subItemOf !== undefined) {
        if (map !== null && map[it1.subItemOf] !== null) {
          valIt1 = map[it1.subItemOf] + it2.value;
        } else {
          valIt1 = it1.value;
        }
      } else {
        valIt1 = it1.value;
      }
      let valIt2 = "";
      if (it2.subItemOf !== undefined) {
        if (map !== null && map[it2.subItemOf] !== null) {
          valIt2 = map[it2.subItemOf] + it2.value;
        } else {
          valIt1 = it2.value;
        }
      } else {
        valIt2 = it2.value;
      }
      return valIt1.trim() < valIt2.trim() ? -1 : 1;
    });
    return _listToBeDisplayed;
  }

  private getChildrenFor(id: number, relationObject: MapRelations): number[] {
    const childrens: number[] = [];
    Object.keys(relationObject).forEach(key => {
      if (relationObject[key] === id) {
        childrens.push(Number(key));
      }
    });
    return childrens;
  }

  get titleList(): string {
    let title = "";
    switch (this.selectedList) {
      case ListToBeDisplayed.None: {
        title = "";
        break;
      }
      case ListToBeDisplayed.Process: {
        title = "Process";
        break;
      }
      case ListToBeDisplayed.Reason: {
        title = "Reason";
        break;
      }
      case ListToBeDisplayed.Stakeholder: {
        title = "Stakeholder";
        break;
      }
      default: {
        title = "";
        break;
      }
    }
    return title;
  }

  get shouldDisplayReset(): boolean {
    return (
      store.state.delayCodes.selectedStakeholderId !== null ||
      store.state.delayCodes.selectedProcessId !== null ||
      store.state.delayCodes.selectedReasonId !== null ||
      store.state.delayCodes.selectedGroupingId !== null
    );
  }

  reset = () => {
    store.commit.delayCodes[MutationsTypes.RESET_SELECTION]();
  };

  goToBreakdown = () => {
    this.$router.push("breakdown");
  };
}
